import styled, { css } from "styled-components";
import { RaceStatusAnimationPayload } from "./types";

const getBackgroundImageForRaceStatusAnimation = (
  raceStatusAnimation: RaceStatusAnimationPayload
) =>
  `
  background-size: 400% 200%;
  background-image: linear-gradient(to right, transparent 50%, ${raceStatusAnimation.backgroundColor} 50%);
  `;

// Creating a new animation, with different name
// to re-trigger it when needed
const getRaceStatusAnimation = (
  raceStatusAnimation: RaceStatusAnimationPayload
) => `
  animation: ${raceStatusAnimation.animationName} 2s;
  @keyframes ${raceStatusAnimation.animationName} {
    from {
      background-position: -100% 0;
      ${/* stylelint-disable */ ""}
      ${getBackgroundImageForRaceStatusAnimation(raceStatusAnimation)}
    }

    to {
      background-position: 0 -100%;
      ${getBackgroundImageForRaceStatusAnimation(raceStatusAnimation)}
      ${/* stylelint-enable */ ""}
    }
  }
`;

const getPosition = (position: "relative" | "absolute") => {
  if (position === "relative") {
    return "position: relative;";
  }

  return "position: absolute; top: 0; left: 0;";
};

const AvailableBetTypesDimensions = `
  width: 94px;
  height: 60px;
`;

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
`;

export const TrackSummaryInfo = styled.div<{
  position: "relative" | "absolute";
  longerMtp: boolean;
}>`
  display: flex;
  flex-direction: column;
  z-index: 2;
  ${({ position }) => getPosition(position)}

  & > div {
    /* Force DS MTPCell to cover the Available Bet Types */
    ${AvailableBetTypesDimensions};
    border-bottom: 1px solid ${({ theme }) => theme.colorTokens.border.default};

    /* Force DS MTPCell to decrease font-size on its longer versions to prevent line breaking
     Note: we're using MPTCell with a fixed width to cover the Available Bet Types
     and with an absolute position to be on top of DS Bet Type Selector) */
    ${({ longerMtp }) =>
      longerMtp &&
      css`
        & > p:first-child {
          font-size: 16px;
        }
      `};
  }
`;

export const TrackSummaryAnimationSlider = styled.div<{
  position: "relative" | "absolute";
  raceStatusAnimation: RaceStatusAnimationPayload | null;
}>`
  ${AvailableBetTypesDimensions}
  ${({ position }) => getPosition(position)}
  ${({ raceStatusAnimation }) =>
    raceStatusAnimation && getRaceStatusAnimation(raceStatusAnimation)}
`;

export const RaceNotOpenWrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  background-color: ${({ theme }) => theme.colorTokens.background.surface};
  border-bottom: 1px solid ${({ theme }) => theme.colorTokens.border.default};
`;

export const RaceNotOpenAlertWrapper = styled.div`
  width: 100%;

  /* Remove border from the Alert Inline DS Component to prevent having duplicated borders
   since there is already a border on the Wrapper */
  & > :first-child > div {
    border-bottom: none;
  }
`;
